import styled from 'styled-components'
import * as theme from '../theme'

export const Input = styled.input`
   background: ${theme.color.white};
   padding: ${theme.spacing.s} ${theme.spacing.sm};
   border-radius: ${theme.border.radius};
   border: 1px solid ${theme.color.border};
   cursor: pointer;
   -webkit-appearance: none;
   width: 100%;
   margin: ${theme.spacing.xs} 0;
   max-width: ${props => (props.maxWidth ? props.maxWidth : '100%')};

   &:hover,
   &:focus {
      border-color: ${theme.color.primary};
   }

   &:invalid {
      border-color: ${theme.color.orange};
   }
`
